module.exports = __webpack_public_path__ + "107a23b8eadf56517b754c2a5d1f7a9c.png";